import template from '../../templates/views/loader.hbs';

require(`../../scss/${process.env.ENTRY_POINT}/loader-config.scss`);

const BODY = 'BODY';
const ARIA_BUSY = 'aria-busy';
const LOADER_CONTAINER_CLASS = 'loader-wrapper';
const PREVENT_SCROLL_CLASS = 'loader-prevent-scroll';
const HAS_LOADER_CLASS = 'has-loader';
const BTN_HIDE_TXT_CLASS = 'btn-hide-txt';

class Loader {
  constructor(selector, color) {
    if (typeof selector !== 'string') {
      throw new Error('Loader: selector must be a string.');
    }

    let templateString = document.createElement('div');

    this.el = document.querySelectorAll(selector)[0];
    this.color = color;
    if (typeof this.el === 'undefined') {
      throw new Error(`Loader: Element node ${selector} is null.`);
    }
    if (this.color === 'undefined') {
      this.color = 'primary';
    }
    if (this.color !== 'primary' && this.color !== 'secondary' && this.color !== 'tertiary') {
      this.color = 'primary';
    }

    if (this.el.classList.contains(HAS_LOADER_CLASS)) {
      this.el.removeChild(this.el.querySelector(`.${LOADER_CONTAINER_CLASS}`));
    }


    this.isButton = this.el.tagName === 'BUTTON' || this.el.classList.contains('button');
    this.isBody = this.el.tagName === BODY;
    this.isVisible = false;

    templateString.innerHTML = template({
      isBody: this.isBody,
      color: this.color,
    });


    this.el.classList.add(HAS_LOADER_CLASS);
    this.el.insertBefore(templateString.firstElementChild, this.el.firstElementChild || null);
    this.childEl = this.el.querySelector(`.${LOADER_CONTAINER_CLASS}`);

    templateString = null;
  }


  show() {
    if (this.isVisible === false) {
      this.isVisible = true;

      if (this.isButton) {
        this.el.classList.add(BTN_HIDE_TXT_CLASS);
      }

      if (this.isBody) {
        this.el.classList.add(PREVENT_SCROLL_CLASS);
      }

      this.el.style.position = 'relative';
      this.el.setAttribute(ARIA_BUSY, true);
      this.childEl.style.display = this.isBody ? 'flex' : 'block';
    }
  }


  hide() {
    if (this.isVisible === true) {
      this.isVisible = false;

      if (this.isButton) {
        this.el.classList.remove(BTN_HIDE_TXT_CLASS);
      }

      if (this.isBody) {
        this.el.classList.remove(PREVENT_SCROLL_CLASS);
      }

      this.el.setAttribute(ARIA_BUSY, 'false');
      this.el.style.position = '';
      this.childEl.style.display = 'none';
    }
  }

  remove() {
    if (this.isButton) {
      this.el.classList.remove(BTN_HIDE_TXT_CLASS);
    }

    if (this.isBody) {
      this.el.classList.remove(PREVENT_SCROLL_CLASS);
    }

    this.el.classList.remove(HAS_LOADER_CLASS);

    this.el.style.position = '';
    this.el.removeAttribute(ARIA_BUSY);
    this.el.removeChild(this.childEl);
    this.isVisible = false;
  }
}


export default Loader;



// WEBPACK FOOTER //
// /Users/m802941/WebstormProjects/2020/campaigns/shop-the-look-pdp/node_modules/@component/loader/src/js/views/loader.js